import { use, useEffect, useState } from "react";

import { useDataStore } from "@store/user_org";
import { useConfigStore } from "@store/persist";

import SettingBar from "@navigation/SettingBar";
import { Account } from "./settings/Account";
import { Company } from "./settings/Company";
import { Team } from "./settings/Team";
import { EmailTemplates } from "./settings/EmailTemplates";
import { Library } from "./settings/Library";
import { ProjectTemplates } from "./settings/ProjectTemplates";
import { FormTemplates } from "./settings/FormTemplates";
import { PlanningTemplates } from "./settings/PlanningTemplates";
import { SyncOperations } from "./settings/SyncOperations";
import { EmailDesigns } from "./settings/EmailDesigns";
import EmailsSentScreen from "./EmailsSentScreen";
import { Disponibilites } from "./settings/disponibilites/Disponibilites";
import { ServiceRapide } from "./settings/service-rapide/ServiceRapide";
import { DispoAtelier } from "./settings/dispo-atelier/DispoAtelier";
import { MessagerieSettings } from "./settings/MessagerieSettings";
import { PriseDeRDV } from "./settings/PriseDeRDV";
import { Interventions } from "./settings/Interventions";
import { Tags } from "./settings/Tags";
import { Avis } from "./settings/Avis";
import { Payments } from "./settings/Payments";
import { Signatures } from "./settings/Signatures";
import { Users } from "./settings/Users";
import { NotificationsSettings } from "./settings/NotificationsSettings";
import { ServiceBoxSettings } from "./settings/ServiceBoxSettings";
import { ThreeCXSettings } from "./settings/ThreeCXSettings";
import { Storage } from "./settings/Storage";
import { DevisReminders } from "./settings/DevisReminders";
import { ProxyDashboard } from "./settings/ProxyDashboard";
import { ReceptionSettings } from "./settings/ReceptionSettings";
import { ServiceBoxSync } from "./settings/ServiceBoxSync";
import { useParams, useSearchParams } from "react-router-dom";

export default function SettingsScreen() {
  const [searchParams] = useSearchParams();
  const orgData = useDataStore((state) => state.orgData);
  const userData = useDataStore((state) => state.userData);
  const prefix = useConfigStore((state) => state.prefix);
  const isAdmin = userData?.config?.admin === true;

  const [page, setPage] = useState<string>(
    searchParams.get("page") || "account",
  );

  useEffect(() => {
    setPage(searchParams.get("page") || "account");
  }, [searchParams]);

  return (
    <div className="flex flex-row max-h-full w-full max-w-full h-screen">
      <SettingBar page={page} setPage={setPage}></SettingBar>
      <div className="flex flex-col w-full h-full overflow-auto">
        <div className="flex flex-col h-full">
          {page === "account" && <Account></Account>}
          {page === "dispo-atelier" && <DispoAtelier />}
          {(page === "disponibilites" || page === "service-rapide") && <DispoAtelier />}{" "}
          {page === "company" && <Company></Company>}{" "}
          {page === "team" && <Team></Team>}{" "}
          {page === "email-templates" && <EmailTemplates></EmailTemplates>}
          {page === "library" && <Library />}
          {page === "project-templates" && <ProjectTemplates />}
          {page === "form-templates" && <FormTemplates />}
          {page === "planning-templates" && <PlanningTemplates />}
          {page === "sync-operations" && <SyncOperations />}
          {page === "email-designs" && <EmailDesigns />}
          {page === "emails-sent" && <EmailsSentScreen />}
          {(page === "whatsapp" || page === "messagerie" || page === "facturation") && <MessagerieSettings />}
          {page === "prise-rdv" && <PriseDeRDV />}
          {page === "receptions" && <ReceptionSettings />}
          {page === "interventions" && <Interventions />}
          {page === "tags" && <Tags />}
          {page === "avis" && <Avis />}
          {page === "signatures" && <Signatures />}
          {page === "paiements" && <Payments />}
          {page === "notifications" && <NotificationsSettings />}
          {page === "servicebox" && <ServiceBoxSettings />}
          {page === "servicebox-sync" && <ServiceBoxSync />}
          {page === "threecx" && <ThreeCXSettings />}
          {page === "stockage" && <Storage />}
          {page === "devis-reminders" && <DevisReminders />}
          {page === "users" && isAdmin && <Users />}
          {page === "proxy-dashboard" && isAdmin && <ProxyDashboard />}
        </div>
      </div>
    </div>
  );
}
